import React from 'react';

// Icons
import { IoFolder } from 'react-icons/io5';
import { FaGraduationCap, FaStickyNote } from "react-icons/fa";

// Components
import Typography from '../Typography';
import Checkbox from '../Checkbox';

// Styles
import styles from './style.module.scss';

// Types
import { Folder, Note, Course } from '../../types';

// Assets
import BooksIcon from '../../components/assets/books.png'
import StudyPathIcon from 'images/icons/studypath.png'

interface ItemProps {
  type: 'folder' | 'note' | 'course';
  item: Folder | Note | Course;
  onSelect: (id: string | number) => void;
  selected: boolean;
  disabled?: boolean;
}

const Item: React.FC<ItemProps> = ({ type, item, onSelect, selected, disabled = false }) => {

  const Icon = () => {
    switch (type) {
      case 'folder':
        return <IoFolder />;
      case 'course':
        return (
          <img src={StudyPathIcon} alt='studypath' className={styles.item_icon} />
        )
      default:
        return (
          <img src={BooksIcon} alt='books' className={styles.item_icon} />
        );
    }
  }

  const Title = () => {
    switch (type) {
      case 'folder':
        return (item as Folder).title;
      case 'note':
        return (item as Note).title;
      case 'course':
        return (item as Course).title;
    }
  }

  return (
    <div className={styles.item} onClick={() => disabled ? null : onSelect(item.id)}>
      <div className={styles.item_content}>
        <div className={styles.item_icon_container}>
          <Icon />
        </div>

        <Typography variant="p">
          {Title()}
        </Typography>
      </div>

      <Checkbox readOnly id={item.id.toString()} checked={selected} />
    </div>
  )
}

export default Item;
